var MediaQuery;
(function (MediaQuery) {
    MediaQuery["Mobile"] = "500px";
    MediaQuery["Tablet"] = "700px";
    MediaQuery["Laptop"] = "1200px";
})(MediaQuery || (MediaQuery = {}));
export default MediaQuery;
//# sourceMappingURL=MediaQuery.js.map